
<script>
import moment from 'moment'

export default {
  name: 'rex-date',
  props: {
    label: {
      type: String,
      default: () => null
    },
    name: {
      type: String,
      required: true
    },
    storeModule: {
      type: String,
      default: () => '',
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    cssClass: {
      type: String,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    showLabel: {
      type: Boolean,
      default: () => true
    },
    validate: {
      type: [String, Object],
      default: () => null
    },
    yearsRange: {
      type: Array,
      default: () => [-100, 3]
    },
    range: {
      type: Object,
      default: () => ({
        minDate: moment().subtract(100, 'years').toDate(),
        maxDate: moment().add(10, 'years').toDate()
      })
    }
  },
  data: () => ({
    focusedDate: new Date(),
  }),
  inject: ['$validator'],
  computed: {
    value() {
      let data = this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)
      data = data !== null
        ? new Date(moment(data, 'DD.MM.YYYY').format('YYYY MM DD'))
        : new Date()

      return data
    },
    error() {
      const target = this.target.split('.')
      const err = this.$store.getters[`${this.storeModule}/${this.getterName}`](`${target[0]}Errors`)
        .find(error => error.field === this.name)

      return err ? err.message : null
    }
  },
  watch: {
    'value'(date) {
      this.focusedDate = date
    }
  },
  methods: {
    updValue(value) {
      const data = moment(value).format('DD.MM.YYYY')

      this.$store.commit(`${this.storeModule}/${this.setterName}`, {
        target: this.target,
        value: data
      })

      if (this.error !== null) {
        const target = this.target.split('.')
        const err = this.$store.getters[`${this.storeModule}/${this.getterName}`](`${target[0]}Errors`)
        const currentFieldErrorIndex = err.map(x => x.field).indexOf(this.name)

        err.splice(currentFieldErrorIndex, 1)
        this.$store.commit(`${this.storeModule}/${this.setterName}`, err)
      }

      this.$emit('onChange', data)
    }
  }
}
</script>

<template>
  <div
    :class="cssClass"
    class="rex-field"
  >
    <h3
      v-if="showLabel"
      class="rex-field--label"
    >
      {{ label }}
    </h3>
    <b-field
      :type="{'is-danger': errors.has(name) || error}"
      :message="errors.first(name) || error"
    >
      <b-datepicker
        v-model="focusedDate"
        v-validate="validate"
        :name="name"
        class="rex-datepicker"
        :years-range="yearsRange"
        :min-date="range.minDate"
        :max-date="range.maxDate"
        :disabled="disabled"
        @input="updValue($event)"
      />
    </b-field>
  </div>
</template>